import React from 'react';
import {
    Modal, Backdrop, Fade, Grid,
    FormControl,
    InputLabel, Input, Button
} from '@material-ui/core';
import './ModalForm.css';

function ModalFormDev(props) {
    //Form pops up when you click LEARN MORE under development on the Services page
    return (
        <div>
            <Modal
                aria-labelledby={props.modalTitle}
                aria-describedby={props.modalDescription}
                className='modal-form'
                open={props.open}
                onClose={props.handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{ timeout: 500 }}>
                <Fade in={props.open}>
                    <form accept-charset="UTF-8" action="https://nv695.infusionsoft.com/app/form/process/d30daef3bf6e1ecd961fb218a0c415b5" class="infusion-form" id="inf_form_d30daef3bf6e1ecd961fb218a0c415b5" method="POST">
                        <input name="inf_form_xid" type="hidden" value="d30daef3bf6e1ecd961fb218a0c415b5" />
                        <input name="inf_form_name" type="hidden" value="development Interest form" />
                        <input name="infusionsoft_version" type="hidden" value="1.70.0.258945" />
                        <h2 className='modal-title'>Development Interest</h2>
                        <Grid container
                            spacing={3}
                            direction="column"
                            justify="center"
                            alignItems="center"
                            className='modal-grid'>
                            <Grid item sm={12}>
                                <FormControl className='popup-input'>
                                    <InputLabel htmlFor="inf_field_FirstName">First Name *</InputLabel>
                                    <Input className='formControl infusion-field-input' id="inf_field_FirstName" name="inf_field_FirstName" type="text" />
                                </FormControl>
                            </Grid>
                            <Grid item sm={12}>
                                <FormControl className='popup-input'>
                                    <InputLabel htmlFor="inf_field_LastName">Last Name *</InputLabel>
                                    <Input className='formControl infusion-field-input' id="inf_field_LastName" name="inf_field_LastName" type="text" />
                                </FormControl>
                            </Grid>
                            <Grid item sm={12}>
                                <FormControl className='popup-input'>
                                    <InputLabel htmlFor="inf_field_Email">Email *</InputLabel>
                                    <Input className='formControl infusion-field-input' id="inf_field_Email" name="inf_field_Email" type="text" />
                                </FormControl>
                            </Grid>
                            {/* <Grid item sm={12}>
                                <FormControl>
                                    <InputLabel id='interest-label' for="inf_custom_Interest">Interest *</InputLabel>
                                    <Select
                                        labelId='interest-label'
                                        id="inf_custom_Interest"
                                        className='select-control formControl'
                                        name='inf_custom_Interest'
                                        value={interest}
                                        onChange={handleSelectChange}>
                                        <MenuItem value='development'>Development</MenuItem>
                                        <MenuItem value='consulting'>Consulting</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid> */}
                        </Grid>
                        <br />
                        <div class="infusion-submit" style={{ textAlign: 'center' }}>
                            <Button type="submit" variant='contained' className='submit-btn'>Submit</Button>
                        </div>
                        <br />
                    </form>
                </Fade>
            </Modal>
            <script type="text/javascript" src="https://nv695.infusionsoft.app/app/webTracking/getTrackingCode"></script>
            <script type="text/javascript" src="https://nv695.infusionsoft.com/app/timezone/timezoneInputJs?xid=d30daef3bf6e1ecd961fb218a0c415b5"></script>
        </div>
    )
}

export default ModalFormDev;
